module.exports = __webpack_public_path__ + "img/Wevent_Logo_only_text_black_small.14183756.svg";